
export const TOGGLE_REMOVE_CONVERSATION_AUTOMATION = 'TOGGLE_REMOVE_CONVERSATION_AUTOMATION';
export const CREATE_REMOVE_CONVERSATION_AUTOMATION= 'CREATE_REMOVE_CONVERSATION_AUTOMATION';
export const UPDATE_REMOVE_CONVERSATION_AUTOMATION= 'UPDATE_REMOVE_CONVERSATION_AUTOMATION';
export const GET_REMOVE_CONVERSATION_AUTOMATION_DATA= 'GET_REMOVE_CONVERSATION_AUTOMATION_DATA';
export const TOGGLE_REMOVE_CONVERSATION_SETTINGS_VIEW = 'TOGGLE_REMOVE_CONVERSATION_SETTINGS_VIEW';